import { initializeApp, getApp, getApps } from "firebase/app";
import { GoogleAuthProvider, getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAKzYwQMw3gjc-dnAB6xcK8_paXmK5VdWM",
  authDomain: "flamingo-b40a6.firebaseapp.com",
  projectId: "flamingo-b40a6",
  storageBucket: "flamingo-b40a6.appspot.com",
  messagingSenderId: "437133391904",
  appId: "1:437133391904:web:6a499daea2204481a02445",
  measurementId: "G-30715F210F",
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const firestore = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

export { firestore, app, auth, storage, googleProvider };
